<main *ngIf="loginRole === 'superadmin' || loginRole === 'csqadmin'">
  <div class="d-grid gap-3">
    <div
      class="d-flex justify-content-between align-items-center width-class w-100 flex-wrap gap-3"
    >
      <div
        class="d-flex gap-3 align-items-center"
        style="cursor: pointer"
        (click)="!pageloading && goBack()"
      >
        <img
          class="action-button"
          [class.skeleton-img]="pageloading"
          src="../../../../../assets/images/Buttons/arrow-left.svg"
          alt="left"
        />
        <div class="header-text m-0" [class.skeleton-text]="pageloading">
          Back to event list
        </div>
      </div>
    </div>

    <div class="event-card">
      <div class="w-100 d-grid gap-3 align-items-baseline">
        <div
          class="d-flex w-100 justify-content-between align-items-start flex-wrap gap-2"
        >
          <div class="d-flex gap-2 align-items-center flex-wrap">
            <span class="event-name" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.eventName || "Event Name"
              }}
            </span>
          </div>

          <div class="d-grid gap-2 status-text" *ngIf="!pageloading">
            Status
            <div class="status-dropdown-container">
              <div
                class="status-display"
                [ngClass]="
                  getStatusClass(eventData?.eventAdminApprovalStatusName)
                "
                [style.cursor]="'default'"
              >
                {{
                  getStatusDisplayValue(
                    eventData?.eventAdminApprovalStatusName === "Pending"
                      ? "Awaiting Approval"
                      : eventData.eventAdminApprovalStatusName
                  )
                }}
              </div>
              <div class="status-skeleton" *ngIf="pageloading"></div>
            </div>
          </div>
        </div>

        <div class="details-layout">
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Type of work experience
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.workExperienceTypeName || "-"
              }}
            </div>
            <div class="small-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.workExperienceDesc || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Student name
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.studentName || "-" }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Start date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventStartDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              End date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventEndDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
        </div>

        <div class="details-layout">
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              No. of days
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.noOfDays || "-" }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Time
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.eventTime || "-" }}
            </div>
          </div>

          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Company / Employer
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.employerName || "-" }}
            </div>
          </div>

          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Location
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.location || "-" }}
            </div>
          </div>

          <div class="d-flex justify-content-end" style="grid-column: 1 / -1;">
            <button
              class="evidence-button"
              *ngIf="eventData?.imagePaths?.length > 0"
            >
              <div class="time">
                <div
                  *ngIf="getEventImage() && !isPdf()"
                  style="max-width: 200px"
                  class="d-flex gap-2 align-items-center px-2"
                  (click)="downloadFiles()"
                >
                  <img
                    class="download-icon"
                    style="filter: brightness(5); width: 20px; height: 20px"
                    src="assets/images/Buttons/view-button.svg"
                    alt="download"
                  />
                  View evidence
                </div>

                <div
                  *ngIf="getEventImage() && isPdf()"
                  style="max-width: 200px"
                  class="d-flex gap-2 align-items-center px-2"
                  (click)="downloadFiles()"
                >
                  <img
                    class="download-icon"
                    src="assets/images/download-icon.svg"
                    alt="download"
                  />
                  Download evidence
                </div>
              </div>
            </button>
          </div>
        </div>

        <div
          class="reason-section"
          *ngIf="
            eventData?.eventTeacherApprovalComment &&
            eventData?.eventTeacherApprovalStatusName !== 'Approved'
          "
        >
          <div class="reason-subText">Reason for declining</div>
          <div class="reason-subText">
            Declined by: {{ eventData?.declinedBy }}
          </div>
          <div>
            {{ eventData?.eventTeacherApprovalComment }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="showEventModal" (click)="closeEventModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div>View evidence</div>
        <button class="close-btn" (click)="closeEventModal()">&times;</button>
      </div>

      <div class="modal-body">
        <img [src]="showEventModal" alt="Event Image" />
      </div>
    </div>
  </div>
</main>

<main *ngIf="loginRole === 'csquser'">
  <div class="d-grid gap-3">
    <div
      class="d-flex justify-content-between align-items-center width-class w-100 flex-wrap gap-3"
    >
      <div
        class="d-flex gap-3 align-items-center"
        style="cursor: pointer"
        (click)="!pageloading && goBack()"
      >
        <img
          class="action-button"
          [class.skeleton-img]="pageloading"
          src="../../../../../assets/images/Buttons/arrow-left.svg"
          alt="left"
        />
        <div class="header-text m-0" [class.skeleton-text]="pageloading">
          Back to event list
        </div>
      </div>
    </div>

    <div class="event-card">
      <div class="w-100 d-grid gap-3 align-items-baseline">
        <div
          class="d-flex w-100 justify-content-between align-items-start flex-wrap gap-2"
        >
          <div class="d-flex gap-2 align-items-center flex-wrap">
            <span class="event-name" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.eventName || "Event Name"
              }}
            </span>
          </div>

          <div class="d-grid gap-2 status-text" *ngIf="!pageloading">
            Status
            <div class="status-dropdown-container">
              <div
                class="status-display"
                [ngClass]="
                  getStatusClass(eventData?.eventAdminApprovalStatusName)
                "
                [style.cursor]="'default'"
              >
                {{
                  getStatusDisplayValue(
                    eventData?.eventAdminApprovalStatusName === "Pending"
                      ? "Awaiting Approval"
                      : eventData.eventAdminApprovalStatusName
                  )
                }}
              </div>
              <div class="status-skeleton" *ngIf="pageloading"></div>
            </div>
          </div>
        </div>

        <div class="details-layout">
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Type of work experience
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.workExperienceTypeName || "-"
              }}
            </div>
            <div class="small-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.workExperienceDesc || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Student name
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.studentName || "-" }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Start date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventStartDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              End date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventEndDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
        </div>

        <div class="details-layout">
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              No. of days
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.noOfDays || "-" }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Time
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.eventTime || "-" }}
            </div>
          </div>

          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Company / Employer
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.employerName || "-" }}
            </div>
          </div>

          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Location
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.location || "-" }}
            </div>
          </div>

          <div class="d-flex justify-content-end" style="grid-column: 1 / -1;">
            <button
              class="evidence-button"
              *ngIf="eventData?.imagePaths?.length > 0"
            >
              <div class="time">
                <div
                  *ngIf="getEventImage() && !isPdf()"
                  style="max-width: 200px"
                  class="d-flex gap-2 align-items-center px-2"
                  (click)="downloadFiles()"
                >
                  <img
                    class="download-icon"
                    style="filter: brightness(5); width: 20px; height: 20px"
                    src="assets/images/Buttons/view-button.svg"
                    alt="download"
                  />
                  View evidence
                </div>

                <div
                  *ngIf="getEventImage() && isPdf()"
                  style="max-width: 200px"
                  class="d-flex gap-2 align-items-center px-2"
                  (click)="downloadFiles()"
                >
                  <img
                    class="download-icon"
                    src="assets/images/download-icon.svg"
                    alt="download"
                  />
                  Download evidence
                </div>
              </div>
            </button>
          </div>
        </div>

        <div
          class="reason-section"
          *ngIf="
            eventData?.eventTeacherApprovalComment &&
            eventData?.eventTeacherApprovalStatusName !== 'Approved'
          "
        >
          <div class="reason-subText">Reason for declining</div>
          <div class="reason-subText">
            Declined by: {{ eventData?.declinedBy }}
          </div>
          <div>
            {{ eventData?.eventTeacherApprovalComment }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="showEventModal" (click)="closeEventModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div>View evidence</div>
        <button class="close-btn" (click)="closeEventModal()">&times;</button>
      </div>

      <div class="modal-body">
        <img [src]="showEventModal" alt="Event Image" />
      </div>
    </div>
  </div>
</main>

<main *ngIf="loginRole === 'teacher'">
  <div class="d-grid gap-3">
    <div
      class="d-flex justify-content-between align-items-center width-class w-100 flex-wrap gap-3"
    >
      <div
        class="d-flex gap-3 align-items-center"
        style="cursor: pointer"
        (click)="!pageloading && goBack()"
      >
        <img
          class="action-button"
          [class.skeleton-img]="pageloading"
          src="../../../../../assets/images/Buttons/arrow-left.svg"
          alt="left"
        />
        <div class="header-text m-0" [class.skeleton-text]="pageloading">
          Back to event list
        </div>
      </div>
    </div>

    <div class="event-card">
      <div class="w-100 d-grid gap-3 align-items-baseline">
        <div
          class="d-flex w-100 justify-content-between align-items-start flex-wrap gap-2"
        >
          <div class="d-flex gap-2 align-items-center flex-wrap">
            <span class="event-name" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.eventName || "Event Name"
              }}
            </span>
          </div>

          <div class="d-grid gap-2 status-text" *ngIf="!pageloading">
            Status
            <div class="status-dropdown-container">
              <div
                class="status-display"
                [ngClass]="
                  getStatusClass(eventData?.eventTeacherApprovalStatusName)
                "
                [style.cursor]="'default'"
              >
                {{
                  getStatusDisplayValue(
                    eventData?.eventTeacherApprovalStatusName === "Pending"
                      ? "Awaiting Approval"
                      : eventData?.eventTeacherApprovalStatusName
                  )

                }}
              </div>
              <div class="status-skeleton" *ngIf="pageloading"></div>
            </div>
          </div>
        </div>

        <div class="details-layout">
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Type of work experience
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.workExperienceTypeName || "-"
              }}
            </div>
            <div class="small-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.workExperienceDesc || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Student name
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.studentName || "-" }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Start date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventStartDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              End date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventEndDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
        </div>

        <div class="details-layout">
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              No. of days
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.noOfDays || "-" }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Time
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.eventTime || "-" }}
            </div>
          </div>

          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Company / Employer
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.employerName || "-" }}
            </div>
          </div>

          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Location
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.location || "-" }}
            </div>
          </div>

          <div class="d-flex justify-content-end" *ngIf="!pageloading">
            <button
              class="evidence-button"
              *ngIf="eventData?.imagePaths?.length > 0"
            >
              <div class="time">
                <div
                  *ngIf="getEventImage() && !isPdf()"
                  style="max-width: 200px"
                  class="d-flex gap-2 align-items-center px-2"
                  (click)="downloadFiles()"
                >
                  <img
                    class="download-icon"
                    style="filter: brightness(5); width: 20px; height: 20px"
                    src="assets/images/Buttons/view-button.svg"
                    alt="download"
                  />
                  View evidence
                </div>

                <div
                  *ngIf="getEventImage() && isPdf()"
                  style="max-width: 200px"
                  class="d-flex gap-2 align-items-center px-2"
                  (click)="downloadFiles()"
                >
                  <img
                    class="download-icon"
                    src="assets/images/download-icon.svg"
                    alt="download"
                  />
                  Download evidence
                </div>
              </div>
            </button>
          </div>
        </div>

        <div
          class="reason-section"
          *ngIf="
            eventData?.eventTeacherApprovalComment &&
            eventData?.eventTeacherApprovalStatusName !== 'Approved'
          "
        >
          <div class="reason-subText">Reason for declining</div>
          <div class="reason-subText">
            Declined by: {{ eventData?.declinedBy }}
          </div>
          <div>
            {{ eventData?.eventTeacherApprovalComment }}
          </div>
        </div>

        <div
          class="d-flex justify-content-end gap-3"
          *ngIf="
            !pageloading &&
            eventData?.eventTeacherApprovalStatusName === 'Pending'
          "
        >
          <button class="decline-btn" (click)="declineEvent()">Decline</button>
          <button class="approve-btn" (click)="approveEvent('Approve')">
            Approve
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="showEventModal" (click)="closeEventModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div>View evidence</div>
        <button class="close-btn" (click)="closeEventModal()">&times;</button>
      </div>

      <div class="modal-body">
        <img [src]="showEventModal" alt="Event Image" />
      </div>
    </div>
  </div>
</main>

<main *ngIf="loginRole === 'student' && !isFetchingStudentData">
  <div class="d-grid gap-3">
    <div
      class="d-flex justify-content-between align-items-center width-class w-100 flex-wrap gap-3"
    >
      <div
        class="d-flex gap-3 align-items-center"
        style="cursor: pointer"
        (click)="!pageloading && goBack()"
      >
        <img
          class="action-button"
          [class.skeleton-img]="pageloading"
          src="../../../../../assets/images/Buttons/arrow-left.svg"
          alt="left"
        />
        <div class="header-text m-0" [class.skeleton-text]="pageloading">
          Back to event list
        </div>
      </div>
    </div>

    <div class="event-card">
      <div class="w-100 d-grid gap-3 align-items-baseline">
        <div
          class="d-flex w-100 justify-content-between align-items-start flex-wrap gap-2"
        >
          <div class="d-flex gap-2 align-items-center flex-wrap">
            <span class="event-name" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.eventName || "Event Name"
              }}
            </span>
          </div>
          <div class="d-flex gap-4">
            <div class="d-grid gap-2 status-text" *ngIf="!pageloading">
              Status
              <div class="status-dropdown-container">
                <div
                  class="status-display"
                  [ngClass]="getStatusClass(eventData?.status)"
                  [style.cursor]="'default'"
                >
                  {{ getStatusDisplayValue(eventData?.status) }}
                </div>
                <div class="status-skeleton" *ngIf="pageloading"></div>
              </div>
            </div>

            <div *ngIf="eventData?.status !== 'Approved'">
              <div
                class="blue-text"
                (click)="!pageloading && onEdit(eventData)"
                style="cursor: pointer"
              >
                <img
                  class="action-button"
                  [class.skeleton-img]="pageloading"
                  src="assets/images/Buttons/edit-button.svg"
                  alt="Edit"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="details-layout">
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Type of work experience
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.workExperienceTypeName || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Start date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventStartDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              End date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventEndDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              No. of days
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.noOfDays || "-" }}
            </div>
          </div>
        </div>

        <div class="details-layout">
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Time
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.eventTime || "-" }}
            </div>
          </div>

          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Company / Employer
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.employerName || "-" }}
            </div>
          </div>

          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Location
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.location || "-" }}
            </div>
          </div>

          <div class="d-flex justify-content-end" *ngIf="!pageloading">
            <button
              class="evidence-button"
              *ngIf="eventData?.imagePaths?.length > 0"
            >
              <div class="time">
                <div
                  *ngIf="getEventImage() && !isPdf()"
                  style="max-width: 200px"
                  class="d-flex gap-2 align-items-center px-2"
                  (click)="downloadFiles()"
                >
                  <img
                    class="download-icon"
                    style="filter: brightness(5); width: 20px; height: 20px"
                    src="assets/images/Buttons/view-button.svg"
                    alt="download"
                  />
                  View evidence
                </div>

                <div
                  *ngIf="getEventImage() && isPdf()"
                  style="max-width: 200px"
                  class="d-flex gap-2 align-items-center px-2"
                  (click)="downloadFiles()"
                >
                  <img
                    class="download-icon"
                    src="assets/images/download-icon.svg"
                    alt="download"
                  />
                  Download evidence
                </div>
              </div>
            </button>
          </div>
        </div>

        <div class="reason-section" *ngIf="eventData?.teacherDeclineReason">
          <div class="reason-subText">Reason for declining</div>
          <div class="reason-subText">
            Declined by: {{ eventData?.declinedBy }}
          </div>
          <div>
            {{ eventData?.teacherDeclineReason }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="showEventModal" (click)="closeEventModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div>View evidence</div>
        <button class="close-btn" (click)="closeEventModal()">&times;</button>
      </div>

      <div class="modal-body">
        <img [src]="showEventModal" alt="Event Image" />
      </div>
    </div>
  </div>
</main>
